exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_articles_nwhqPwizXBS-rb-BkyLev {\n  position: relative;\n  width: 100%;\n  height: auto;\n  float: left;\n}\n\n.IA_filters_3ifPSJqfqB3pM5LbFVa1vA {\n  width: 100%;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: row;\n}\n\n.IA_paginationButtonContainer_psi2_QgurGXLlWQiGrroQ {\n  width: 100%;\n  height: 30px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.IA_paginationPageCount_1_W_oYOGHRKs2EpcwimJcJ {\n  text-align: center;\n}", ""]);

// Exports
exports.locals = {
	"IA_articles": "IA_articles_nwhqPwizXBS-rb-BkyLev",
	"IA_filters": "IA_filters_3ifPSJqfqB3pM5LbFVa1vA",
	"IA_paginationButtonContainer": "IA_paginationButtonContainer_psi2_QgurGXLlWQiGrroQ",
	"IA_paginationPageCount": "IA_paginationPageCount_1_W_oYOGHRKs2EpcwimJcJ"
};